import { ChartColorPalette } from 'pages/ReportsPage/components/AnalyticsDashboards/chartColors/chartColors.types';

export const REPORTS_PAGE_COLORS = {
  gridLine: '#E8E8E8',
  axisLabel: '#888',
  textPrimary: '#333',
  lightenFallback: '#EAEAF2',
  heatMapZero: '#F5F5F5',
} as const;

export function createHeatMapColorScale(baseHex: string): (value: number, max: number) => string {
  const r = parseInt(baseHex.slice(1, 3), 16);
  const g = parseInt(baseHex.slice(3, 5), 16);
  const b = parseInt(baseHex.slice(5, 7), 16);
  return (value: number, max: number) => {
    if (value === 0) return REPORTS_PAGE_COLORS.heatMapZero;
    const t = Math.max(0.2, value / max);
    const mix = (c: number) => Math.round(255 - (255 - c) * t);
    return `rgb(${mix(r)},${mix(g)},${mix(b)})`;
  };
}

const THRESHOLD_COLORS = {
  onTarget: '#0D6E6E',
  monitor: '#3A7CA5',
  attention: '#D4A017',
  critical: '#C62828',
} as const;

export const bookjanePalette: ChartColorPalette = {
  chartColors: [
    '#4E4785',
    '#00C18C',
    '#8080BA',
    '#1C0F51',
    '#5BCCAE',
    '#6B5EA6',
    '#2E8B7A',
    '#A390D4',
  ],
  threshold: THRESHOLD_COLORS,
  indicator: {
    positive: '#006F62',
    negative: '#AC1936',
    neutral: '#6D7682',
  },
};

export const accushieldPalette: ChartColorPalette = {
  chartColors: [
    '#1A6B8A',
    '#26A69A',
    '#5DADE2',
    '#0E4D64',
    '#48C9B0',
    '#2E86C1',
    '#148F77',
    '#85C1E9',
  ],
  threshold: THRESHOLD_COLORS,
  indicator: {
    positive: '#1B8A6B',
    negative: '#C0392B',
    neutral: '#6D7682',
  },
};

export const petalPalette: ChartColorPalette = {
  chartColors: [
    '#8E44AD',
    '#C39BD3',
    '#6C3483',
    '#D2B4DE',
    '#A569BD',
    '#7D3C98',
    '#BB8FCE',
    '#5B2C6F',
  ],
  threshold: THRESHOLD_COLORS,
  indicator: {
    positive: '#27AE60',
    negative: '#E74C3C',
    neutral: '#6D7682',
  },
};
